/// <reference path="../../jQuery/jquery-1.4.1-vsdoc.js"/>
if (!stuller)
	var stuller = {};

stuller.popup = function() {
	var pub = {
		timer: {},		
		OpenOrRefresh: function(id) {
			clearTimeout(this.timer[id]);
			$('#' + id).show();
		},
		startExpireTimer: function(id) {
			var timeoutArg = '$(\'#' + id + '\').hide();';
			stuller.popup.timer[id] = setTimeout(timeoutArg, 500);
		}
	};
	return pub;
}();
